// utils
import request from '../utils/Request'

class ContextService {

  async getData(context) {
    const url = `${process.env.REACT_APP_API_MAIN}/context/${context}`
    const result = await request.get(url)
    return result
  }

  async postAnexo(data, context) {
    const url = `${process.env.REACT_APP_API_MAIN}/paciente/anexos${context ? `/${context}` : ''}`
    const result = await request.post(url, {}, JSON.stringify(data))
    return result
  }

  async deleteAnexo(id, context) {
    const url = `${process.env.REACT_APP_API_MAIN}/paciente/anexos/${id}${context ? `/${context}` : ''}`
    const result = await request.delete(url)
    return result
  }

  async postDocPaciente(data) {
    const url = `${process.env.REACT_APP_API_MAIN}/paciente/doc`
    const result = await request.post(url, {}, JSON.stringify(data))
    return result
  }

}

export default new ContextService()
